import React, {useEffect, useState} from 'react';


export interface LazyImgProps extends React.ImgHTMLAttributes {
    targetRef?: React.LegacyRef,
    readAsBlob?: boolean,
}

function LazyImg({src: lp, targetRef, ...restProps}: LazyImgProps) {

    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        setLoaded(false);
    }, [lp]);

    const {
        onLoad,
        onError,
        loading,
        decoding,
        style,
        alt,
        ...imgProps
    } = restProps;

    return (
        <img
            src={lp}
            alt={alt || "Stephane Kamwa"}
            loading={loading || "lazy"}
            decoding={decoding || "async"}
            style={{
                opacity: loaded ? 1 : 0,
                transition: 'opacity 0.2s ease',
                ...style
            }}
            onLoad={(event) => {
                setLoaded(true);
                if (onLoad) onLoad(event);
            }}
            onError={(event) => {
                setLoaded(true);
                if (onError) onError(event);
            }}
            {...imgProps}
            ref={targetRef}
        />
    );
}

LazyImg.defaultProps = {
    readAsBlob: true
}

export default LazyImg;
